import React, { useContext, useEffect } from "react";
import AppDataContext from "../../context/AppDataContext";
import useWindowSize from "../../hooks/useWindowSize";
import HelpCard from "./components/HelpCard/HelpCard";
import RiskHealthCard from "./components/RiskHealthCard/RiskHealthCard";
import totalRiskManaged from "../../assets/images/temp/TotalRiskManaged.png";
import BusinessObjectives from "./components/BusinessObjectives/BusinessObjectives";
import Incidents from "./components/Incidents/Incidents";
import MediaSentiment from "./components/MediaSentiments/MediaSentiments";
import RiskUniverse from "../RiskUniverse/RiskUniverse";

export default function Home() {
  const { setHeaderShow, setHeaderData, user }: any =
    useContext(AppDataContext);
  const { isUltraWide } = useWindowSize();

  useEffect(() => {
    setHeaderShow(!isUltraWide);
    setHeaderData({
      title: `Welcome back ${user.fullName && user.fullName}`,
    });
  }, [isUltraWide, user]);

  return (
    <>
      {!isUltraWide && (
        <div className="container-fluid">
          <div className="row fh mt-3">
            <div className="col-md-4 fh">
              <HelpCard></HelpCard>
            </div>
            <div className="col-md-8">
              <RiskHealthCard></RiskHealthCard>

              <div className="row">
                <div className="col-md-6">
                  <BusinessObjectives></BusinessObjectives>
                </div>
                <div className="col-md-6">
                  <div className="row gt-2">
                    <div className="col-md-6">
                      <Incidents></Incidents>
                    </div>
                    <div className="col-md-6">
                      <MediaSentiment></MediaSentiment>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <img
                        src={totalRiskManaged}
                        style={{ width: "100%" }}
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/*  */}
      {/* Only For Ultra wide Screens */}
      {isUltraWide && (
        <RiskUniverse />
      )}
    </>
  );
}
